import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrganisationUserState } from './types';

const initialState: OrganisationUserState = {
  loading: false,
  error: undefined,
  current: undefined,
};

const organisationUserSlice = createSlice({
  name: 'organisationUserSlice',
  initialState,
  reducers: {
    getCurrentOrganisationUserAction: (
      state: OrganisationUserState,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- This is required to pass the organisation and user IDs to the saga
      _: PayloadAction<{ organisationId: string; userId: string }>,
    ) => ({
      ...state,
      loading: true,
      error: undefined,
    }),
    setCurrentOrganisationUserAction: (
      state: OrganisationUserState,
      action: PayloadAction<{ user: NonNullable<OrganisationUserState['current']> }>,
    ) => ({
      ...state,
      loading: false,
      error: undefined,
      current: action.payload.user,
    }),
    setOrganisationUserErrorAction: (state: OrganisationUserState, action: PayloadAction<{ error: Error }>) => ({
      ...state,
      loading: false,
      error: action.payload.error,
    }),
    clearCurrentOrganisationUserAction: (state: OrganisationUserState) => ({
      ...state,
      loading: false,
      error: undefined,
      current: undefined,
    }),
  },
});

export const { actions: organisationUserActions, reducer: organisationUserReducers } = organisationUserSlice;
